/* eslint-disable react/no-danger,react/prop-types */
import React from 'react';
import './style.scss';

// eslint-disable-next-line react/prop-types
const PageFAQ = ({ faq }) => (
    <div className="page-faq">
        <div className="title is-size-4-touch is-size-3-desktop is-spaced">
            FAQ
        </div>
        {
            faq.map(({ question, answer }) => (
                <div className="page-faq__item">
                    <div className="page-faq__item__question title is-size-5-touch is-size-4-desktop is-spaced">
                        {question}
                    </div>
                    <div
                        className="page-faq__item__answer subtitle is-size-6-touch is-size-5-desktop"
                        dangerouslySetInnerHTML={{
                            __html:
                                Array.isArray(answer)
                                    ? answer.join('<br /><br />')
                                    : answer,
                        }}
                    />

                </div>
            ))
        }
    </div>
);

PageFAQ.propTypes = {

};

export default PageFAQ;
